// USAGE
// $(document).ready(function() {
//     var dp1 = new datepicker('dp1', 'date', true);

//     $('#bn_date').click(function(e) {
//         dp1.showDlg();

//         e.stopPropagation();
//         return false;
//     });
// });

export interface IAccessibleDatePickerModule {
  accessibleDatePickerForceGridFocus: (
    closer: any,
    event: JQuery.ClickEvent<HTMLDivElement>,
    datepickerObject: IDatepicker
  ) => any;
  accessibleDatePicker: (
    id: string,
    target: string,
    timepicker?: boolean | IDatepickerOptions,
    modal?: boolean,
    callBackFn?: () => any
  ) => any;
}

interface IDatepicker {
  [key: string]: any;
}

function accessibleDatePickerForceGridFocus(
  closer: any,
  event: JQuery.ClickEvent<HTMLDivElement>,
  datepickerObject: IDatepicker
) {
  const linkedDatepicker = $($(closer).data('linked-datepicker'));
  const key = event.which || event.charCode || event.keyCode;

  // console.log(event);
  // console.log(linkedDatepicker);
  // console.log(key);
  if (key === 1) {
    datepickerObject.hideDlg();
  } else {
    linkedDatepicker.find('.cal').focus();
    event.preventDefault();
    event.stopPropagation();
    return false;
  }
  return true;
}

interface IDatepickerOptions {
  callBackFn?: () => any;
  showTime?: boolean;
  yearRange?: string;
}

function accessibleDatePicker(
  id: string,
  target: string,
  timepicker: boolean | IDatepickerOptions = false,
  modal = true,
  callBackFn?: () => any
) {
  // timepicker will not be an object, instead of boolean, to allow for more options down the line
  const useTimePicker =
    typeof timepicker === 'boolean' ? timepicker : (timepicker as IDatepickerOptions).showTime;
  const limitYears =
    typeof timepicker === 'object' ? (timepicker as IDatepickerOptions).yearRange : false;
  let _callBackFn;
  if (callBackFn) {
    _callBackFn = callBackFn;
  } else if (typeof timepicker === 'object' && (timepicker as IDatepickerOptions).callBackFn) {
    _callBackFn = (timepicker as IDatepickerOptions).callBackFn;
  }

  // this.uniqueId = window.moment().unix();
  this.uniqueId = this.getUUID();
  this.$id = $(`#${id}`); // element to attach widget to

  this.$accessibleDatepickerCloser = $(`#${id}-accessible-datepicker-closer`); // Document blocker to cover other items
  this.$ariastatusbox = this.$id.find('.ariastatusbox');
  this.$monthObj = this.$id.find('.month');
  this.$prev = this.$id.find('.bn_prev');
  this.$next = this.$id.find('.bn_next');
  this.$grid = this.$id.find('.cal');
  this.$monthSelect = this.$id.find('.dp_month_select');
  this.$yearSelect = this.$id.find('.dp_year_select');
  this.useTimePicker = useTimePicker;
  this.$hourSelect = useTimePicker ? this.$id.find('.dp_hour_select') : null;
  this.$minuteSelect = useTimePicker ? this.$id.find('.dp_minute_select') : null;
  this.$confirmButton = useTimePicker ? this.$id.find('.bn_confirm') : null;
  this.$message = this.$id.find('.adp-msg');
  this.$target = $(`#${target}`); // div or text box that will receive the selected date string and focus (if modal)
  this.isInsideModal = $(`#${target}`).closest('.modal').length === 1;
  this.$modal = $(`#${target}`).closest('.modal');
  this.bModal = modal; // true if datepicker should appear in a modal dialog box.
  this.dateFormat = this.$target.data('date-format') || '';
  this.timeFormat = useTimePicker ? this.$target.data('time-format') : false;
  this.dateSeperator = '-';
  this.dateTimeFormat = this.$target.data('date-time-format');

  const dateMinuteFilter = this.$target.data('date-minute-filter')
    ? this.$target.data('date-minute-filter').split(',')
    : [];
  this.dateMinuteFilter = dateMinuteFilter;

  const dateHourFilter = this.$target.data('date-hour-filter')
    ? this.$target.data('date-hour-filter').split(',')
    : [];
  this.dateHourFilter = dateHourFilter;

  const dateMonthFilter = this.$target.data('date-month-filter')
    ? this.$target.data('date-month-filter').split(',')
    : [];
  this.dateMonthFilter = dateMonthFilter;

  const yearLimits = {
    from: 0,
    to: 0,
  };

  if (limitYears) {
    const limitArr = limitYears.split(':');
    const yearFrom = Number(limitArr[0]);
    const yearTo = Number(limitArr[1]);

    if (yearFrom !== 0) {
      yearLimits.from = yearFrom;
    }
    if (yearTo !== 0) {
      yearLimits.to = yearTo;
    }
  }

  this.yearLimitFrom = yearLimits.from;
  this.yearLimitTo = yearLimits.to;

  this.callBackFn = _callBackFn;

  this.monthNames = (window.DexeroCoreApp.userOptions.datepickerLang as any)[
    window.language
  ].monthNames;
  this.dayNames = (window.DexeroCoreApp.userOptions.datepickerLang as any)[
    window.language
  ].dayNames;

  this.keys = {
    down: 40,
    end: 35,
    enter: 13,
    esc: 27,
    home: 36,
    left: 37,
    pagedown: 34,
    pageup: 33,
    right: 39,
    space: 32,
    tab: 9,
    up: 38,
  };

  this.weekdays = {
    Di: 0,
    Fr: 5,
    Ju: 4,
    Lu: 1,
    Ma: 2,
    Me: 3,
    Mo: 1,
    Sa: 6,
    Su: 0,
    Th: 4,
    Tu: 2,
    Ve: 5,
    We: 3,
  };

  // Limit which dates are selectable
  if (
    typeof this.$target.data('allowed-days') === 'undefined' ||
    this.$target.hasClass('ignore-days-restriction')
  ) {
    this.enabledDaysArray = [0, 1, 2, 3, 4, 5, 6];
    this.ignoreDaysRestriction = true;
  } else {
    this.ignoreDaysRestriction = false;
    this.enabledDaysArray = [];
    $.each(this.$target.data('allowed-days').split(','), (_, value) => {
      const dayId = this.weekdays[value];
      this.enabledDaysArray.push(dayId);
    });
  }

  // Allow for dynamic skipping of days /bi-weekly /tri-weekly /every other day etc.
  if (
    typeof this.$target.data('skip-days') !== 'undefined' &&
    typeof this.$target.data('skip-start') !== 'undefined' &&
    !this.$target.hasClass('ignore-days-restriction')
  ) {
    this.skipNumber = Number(this.$target.data('skip-days'));
    this.skipUnit = 'day';
    this.skipStart = window.moment(this.$target.data('skip-start'));
  } else if (
    typeof this.$target.data('skip-weeks') !== 'undefined' &&
    typeof this.$target.data('skip-start') !== 'undefined' &&
    !this.$target.hasClass('ignore-days-restriction')
  ) {
    this.skipNumber = Number(this.$target.data('skip-weeks'));
    this.skipUnit = 'week';
    this.skipStart = window.moment(this.$target.data('skip-start'));
  } else {
    this.skipNumber = false;
    this.skipUnit = false;
    this.skipStart = false;
  }

  // Force date to be today or later
  this.todayOrGreater = typeof this.$target.data('today-or-greater') !== 'undefined';

  this.dateObj = new Date();
  // Make sure the month of our current date object is allowed by the filter
  const tempMonth =
    this.dateObj.getMonth().toString().length === 1
      ? `0${this.dateObj.getMonth()}`
      : this.dateObj.getMonth().toString();
  if (dateMonthFilter.indexOf(tempMonth) === -1) {
    for (let i = 0; i < 11; i += 1) {
      const iStr = (i + 1).toString().length === 1 ? `0${i + 1}` : i + 1;
      if (dateMonthFilter.indexOf(iStr) !== -1) {
        this.dateObj.setMonth(i);
        break;
      }
    }
  }
  this.curYear = this.dateObj.getFullYear();

  let year = this.curYear;
  if (
    this.yearLimitFrom &&
    this.yearLimitTo &&
    (this.curYear < this.yearLimitFrom || this.curYear > this.yearLimitTo)
  ) {
    year =
      this.yearLimitTo -
      Number(
        parseFloat((Math.abs(this.yearLimitTo - this.yearLimitFrom) / 2).toString()).toFixed(0)
      );
  } else if (this.yearLimitFrom && this.curYear < this.yearLimitFrom) {
    year = this.yearLimitFrom;
  } else if (this.yearLimitTo && this.curYear > this.yearLimitTo) {
    year = this.yearLimitTo;
  }

  this.year = year;

  this.curMonth = this.dateObj.getMonth();
  this.month = this.curMonth;
  this.currentDate = true;

  this.date = this.dateObj.getDate();

  // Check if value is present and set correct values
  this.setCurrentValueIntoObject();
  // populate the calendar grid
  this.popGrid();
  this.setActiveDescendant();

  // display the current month and year in dropdown
  // this.$monthObj.html(this.monthNames[this.month] + ' ' + this.year);
  this.filterMinuteSelect();
  this.filterHourSelect();
  this.buildMonthSelect();
  this.buildYearSelect();

  // Bind all click and press handlers
  this.bindHandlers();

  // hide dialog if in modal mode
  if (this.bModal === true) {
    this.$id.attr('aria-hidden', 'true').removeClass('open');
  }
}

accessibleDatePicker.prototype.alertScreenReader = function alertScreenReader(message: string) {
  $(this.$ariastatusbox).empty().delay(100).append(`<p>${message}</p>`);
};

accessibleDatePicker.prototype.setActiveDescendant = function setActiveDescendant(
  tdId: boolean | string = false
) {
  const $tds = this.$grid.find('tbody > tr > td:not(.empty)');
  const currentActivedescendant = this.$grid.attr('aria-activedescendant');
  const $activeTd = $tds.filter(`#${currentActivedescendant}`);
  let _tdId;

  // To make a cell active dirctly pass into function
  if (tdId) {
    _tdId = tdId;
  } else if ($activeTd.length === 1 && !this.$target.val()) {
    _tdId = $($activeTd).attr('id');
  } else if (
    this.curValueYear === false ||
    this.curValueMonth === false ||
    this.curValueDay === false
  ) {
    // If no value is present in the input, we show current month/year and make "today" the active selected
    // update the table's activedescdendant to point to the current day
    _tdId = $tds.filter('.today').attr('id');
  } else {
    // If there is a value in the input, we'll show the month/year of the input and then select the day selected
    _tdId = `day${this.curValueDay}-${this.uniqueId}`;
  }

  const tdToActivate = $tds.filter(`#${_tdId}`);
  this.$grid.attr('aria-activedescendant', _tdId);
  $tds.removeClass('focus').attr('aria-selected', 'false');
  $(tdToActivate).addClass('focus').attr('aria-selected', 'true');
};

// getUUID() function to create a unique ID for table cells ID generation
// This is necessary in order to have uniqui IDs for the acessability of the datepicker
accessibleDatePicker.prototype.getUUID = function getUUID() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }
  return `${s4()}${s4()}-${s4()}-${s4()}`;
};

// prePendZero() function to add 0 to days with only one number in them
accessibleDatePicker.prototype.prePendZero = function prePendZero(day: number) {
  const dayAsString = String(day);
  return dayAsString.length === 2 ? dayAsString : `0${dayAsString}`;
};

accessibleDatePicker.prototype.getMomentOfValue = function getMomentOfValue(
  strict: boolean = false
) {
  let currentValueMoment;
  const val = this.$target.val();
  if (!val) {
    currentValueMoment = window.moment(
      '',
      window.moment().toMomentFormatString(this.dateTimeFormat),
      strict
    );
    currentValueMoment.isEmpty = () => true;
  } else {
    currentValueMoment = window.moment(
      val,
      window.moment().toMomentFormatString(this.dateTimeFormat),
      strict
    );
    currentValueMoment.isEmpty = () => false;
  }
  return currentValueMoment;
};

// setCurrentValueIntoObject() function to get date object of the value already in input
accessibleDatePicker.prototype.setCurrentValueIntoObject = function setCurrentValueIntoObject() {
  this.curValueYear = false;
  this.curValueMonth = false;
  this.curValueDay = false;
  this.curHours = false;
  this.curMinutes = false;

  const currentValue = this.getMomentOfValue();
  let year;
  let month;
  let day;
  let hours;
  let minutes;

  let valsAreValid = false;

  if (currentValue.isEmpty()) {
    return;
  }

  function validateCurrentValue() {
    if (!currentValue.isValid()) {
      return;
    }

    year = currentValue.year();
    month = currentValue.month();
    day = currentValue.date();
    hours = currentValue.hours();
    minutes = currentValue.minutes();

    if (Number.isNaN(Number(year)) || year > 2100 || year < 1900) {
      return;
    }
    if (Number.isNaN(Number(month)) || month > 11) {
      return;
    }
    if (Number.isNaN(Number(day)) || day > 31) {
      return;
    }
    valsAreValid = true;
  }

  validateCurrentValue();

  if (valsAreValid) {
    this.curValueYear = year;
    this.curValueMonth = month;
    this.curValueDay = day;
    if (this.useTimePicker) {
      this.curHours = hours;
      this.curMinutes = minutes;
      this.$hourSelect.val(DCA.padWithZero(hours, 2, true));
      this.$minuteSelect.val(DCA.padWithZero(minutes, 2, true));
    }
    // Overwrite default values if there was a value in the input, and it's valid.
    // We overwrite the current month with the new month and the current year with the new year
    // setActiveDescendant() will then make sure the correct item is selected
    if (this.curValueYear !== this.year || this.curValueMonth !== this.month) {
      this.currentDate = false;
    }
    this.year = this.curValueYear;
    this.month = this.curValueMonth;
  }
};
// @return false;
// end setCurrentValueIntoObject()

//
// buildMonthSelect()
// Function to build and populate the month select dropdown with valid month names and values
// This function needs to only run once since months never change
accessibleDatePicker.prototype.buildMonthSelect = function buildMonthSelect() {
  // Generate month options
  const _thisMonth = this.month;
  const _dateMonthFilter = this.dateMonthFilter;
  const monthOptions = this.monthNames.map((value: string, index: number) => {
    const selected = _thisMonth === index ? ' selected="selected"' : '';
    const monthNumAsString = (index + 1).toString().length === 1 ? `0${index + 1}` : `${index + 1}`;
    return _dateMonthFilter.indexOf(monthNumAsString) === -1
      ? false
      : `<option value="${index}"${selected}> ${value} </option>`;
  });
  this.$monthSelect.empty().append(monthOptions);
};
// @return false;
// end buildMonthSelect()

//
// filterHourSelect()
// Function to build and populate the month select dropdown with valid month names and values
// This function needs to only run once since months never change
accessibleDatePicker.prototype.filterHourSelect = function filterHourSelect() {
  if (this.$hourSelect) {
    const $options: JQuery<HTMLOptionElement> = this.$hourSelect.find('option');
    const _dateHourFilter = this.dateHourFilter;
    const newOptions: HTMLOptionElement[] = [];
    $options.each((_, option) => {
      if (_dateHourFilter.indexOf(option.value) !== -1) {
        newOptions.push(option);
      }
    });
    this.$hourSelect.empty().append(newOptions);
    this.$hourSelect.val(this.$hourSelect.find('option:first-child').val());
  }
};
// @return false;
// end filterHourSelect()

//
// filterMinuteSelect()
// Function to build and populate the month select dropdown with valid month names and values
// This function needs to only run once since months never change
accessibleDatePicker.prototype.filterMinuteSelect = function filterMinuteSelect() {
  if (this.$minuteSelect) {
    const $options: JQuery<HTMLOptionElement> = this.$minuteSelect.find('option');
    const _dateMinuteFilter = this.dateMinuteFilter;
    const newOptions: HTMLOptionElement[] = [];
    $options.each((i, option) => {
      if (_dateMinuteFilter.indexOf(option.value) !== -1) {
        newOptions.push(option);
      }
    });
    this.$minuteSelect.empty().append(newOptions);
    this.$minuteSelect.val(this.$minuteSelect.find('option:first-child').val());
  }
};
// @return false;
// end filterMinuteSelect()

//
// buildYearSelect()
// Function to build and populate the year select dropdown with valid month names and values
// This function needs to run every time we pop the grid since the user might have changed the year and we need to show at least previous 10 and next 10 years
accessibleDatePicker.prototype.buildYearSelect = function buildYearSelect() {
  // Generate month options
  const _thisyear = this.year;
  const tenYearsAgo = this.yearLimitFrom ? this.yearLimitFrom : _thisyear - 10;
  const tenYearsFromNow = this.yearLimitTo ? this.yearLimitTo : _thisyear + 10;
  const yearsArray: number[] = [];
  const currentOptions = this.$yearSelect.find('option');

  // On first load there will be no years in the years dropdown
  if (currentOptions.length === 0) {
    for (let i = tenYearsAgo; i <= tenYearsFromNow; i += 1) {
      yearsArray.push(i);
    }
    let yearFound = false;
    const yearOptions = yearsArray.map((value, index) => {
      let selected = '';
      if (_thisyear === value) {
        selected = ' selected="selected"';
        yearFound = true;
      } else if (!yearFound && index + 1 === yearsArray.length) {
        selected = ' selected="selected"';
      }
      return `<option value="${value}"${selected}> ${value} </option>`;
    });
    this.$yearSelect.empty().append(yearOptions);
  } else {
    // Once the year dropdown is populated, we only shift years around
    const firstYear = Number($(currentOptions).first().val());
    const lastYear = Number($(currentOptions).last().val());
    const precedingYearsNeeded = _thisyear - firstYear - 10;
    const followingYearsNeeded = lastYear - _thisyear - 10;
    const precedingOptions = [];
    const followingOptions = [];
    let currVal;

    // Only add/trim years if there is no start limit set. If start limit is set, we'll show all years starting from start limit on inital render
    if (!this.yearLimitFrom) {
      if (precedingYearsNeeded < 0) {
        // -6 Negative number means we are going backwards in years and need to add preceding numbers
        currVal = firstYear;
        for (let i = 0; i < Math.abs(precedingYearsNeeded); i += 1) {
          currVal -= 1;
          precedingOptions.push(`<option value="${currVal}"> ${currVal} </option>`);
        }
        this.$yearSelect.prepend(precedingOptions.reverse());
      } else if (precedingYearsNeeded > 0) {
        // 6 Postive number means we are going fowards in time and need to trim old years
        currVal = firstYear;
        for (let i = 0; i < Math.abs(precedingYearsNeeded); i += 1) {
          this.$yearSelect.find(`option[value="${currVal}"]`).remove();
          currVal += 1;
        }
      }
    }

    if (!this.yearLimitTo) {
      if (followingYearsNeeded < 0) {
        // -6 Negative number means we are going backwards in years and need to add preceding numbers
        currVal = lastYear;
        for (let i = 0; i < Math.abs(followingYearsNeeded); i += 1) {
          currVal += 1;
          followingOptions.push(`<option value="${currVal}"> ${currVal} </option>`);
        }
        this.$yearSelect.append(followingOptions);
      } else if (followingYearsNeeded > 0) {
        // 6 Postive number means we are going fowards in time and need to trim old years
        currVal = lastYear;
        for (let i = 0; i < Math.abs(followingYearsNeeded); i += 1) {
          this.$yearSelect.find(`option[value="${currVal}"]`).remove();
          currVal -= 1;
        }
      }
    }
  }
};
// @return false;
// end buildYearSelect()

// popGrid() is a member function to populate the datepicker grid with calendar days
// representing the current month
//
// @return N/A
//
accessibleDatePicker.prototype.popGrid = function popGrid() {
  const numDays = this.calcNumDays(this.year, this.month);
  const startWeekday = this.calcStartWeekday(this.year, this.month);
  // let weekCount = 0;
  let weekday = 0;
  let rowCount = 0;
  let lastRowCount = 0;
  const $tbody = this.$grid.find('tbody');
  let gridCells = `\t<tr role="row" id="row${rowCount}-${this.uniqueId}">\n`;
  const _thismonth = this.month;
  const _thisyear = this.year;
  const now = window.moment().valueOf();
  let curDay;
  let cellId;

  // clear the grid
  $tbody.empty();
  this.$message.empty();

  // Update the month and year selects
  this.$monthSelect.val(this.month);
  this.buildYearSelect();
  this.$yearSelect
    .val(this.year)
    .find('option')
    .each((_: number, opt: HTMLOptionElement) => {
      if (Number(opt.value) === _thisyear) {
        $(opt).prop('selected', true);
      } else {
        $(opt).prop('selected', false);
      }
    });

  // Insert the leading empty cells
  for (weekday = 0; weekday < startWeekday; weekday += 1) {
    gridCells +=
      '\t\t<td class="empty" role="gridcell" tabindex="-1" aria-label="Cellule vide">&nbsp;</td>\n';
  }

  // insert the days of the month.
  for (curDay = 1; curDay <= numDays; curDay += 1) {
    cellId = `day${curDay}-${this.uniqueId}`;

    let cls = '';
    if (!this.ignoreDaysRestriction) {
      // Get current calendar day moment object
      const monthNumberLength = (Math.log(_thismonth + 1) * Math.LOG10E + 1) | 0;
      const dayNumberLength = (Math.log(curDay) * Math.LOG10E + 1) | 0;
      const _thisDate = `${_thisyear}-${
        monthNumberLength === 1 ? `0${_thismonth + 1}` : _thismonth + 1
      }-${dayNumberLength === 1 ? `0${curDay}` : curDay}`;
      const _now = window.moment(_thisDate);

      // If day is restricted, disable it
      if (this.enabledDaysArray.indexOf(weekday) === -1) {
        cls = 'disabled';
      }
      // If day is not restricted, but restricted by skip, disable it

      if (this.skipNumber) {
        if (this.skipUnit === 'week') {
          const skipStartToNowDiff = _now.diff(this.skipStart, 'days');
          const daysToSkip = 7 * this.skipNumber;
          if (skipStartToNowDiff % daysToSkip !== 0) {
            cls = 'disabled';
          }
        } else if (this.skipUnit === 'day') {
          const skipStartToNowDiff = _now.diff(this.skipStart, 'days');
          const daysToSkip = this.skipNumber;
          if (skipStartToNowDiff % daysToSkip !== 0) {
            cls = 'disabled';
          }
        }
      }
      // Allow only newer dates
      if (this.todayOrGreater) {
        if (now > _now.valueOf()) {
          cls = 'disabled';
        }
      }
    }

    if (curDay === this.date && this.currentDate === true) {
      gridCells += `\t\t<td id="${cellId}" class="today ${cls}" aria-label="${this.year} ${
        this.monthNames[this.month]
      } ${curDay}, Aujourd'hui" role="gridcell" tabindex="-1" headers="row${lastRowCount}-${
        this.uniqueId
      } ${this.dayNames[weekday]}-${this.$id.attr('id')}" aria-selected="false">${curDay}</td>`;
    } else {
      gridCells += `\t\t<td id="${cellId}" class="${cls}" role="gridcell" tabindex="-1" headers="row${lastRowCount}'-'${
        this.uniqueId
      } ${this.dayNames[weekday]}-${this.$id.attr('id')}" aria-label="${this.year} ${
        this.monthNames[this.month]
      } ${curDay}" aria-selected="false">${curDay}</td>`;
    }

    if (weekday === 6 && curDay < numDays) {
      // This was the last day of the week, close it out
      // and begin a new one
      lastRowCount = rowCount;
      rowCount += 1;
      gridCells += `\t</tr>\n\t<tr role="row" id="row${rowCount}-${this.uniqueId}">\n`;
      weekday = 0;
      // weekCount += 1;
    } else {
      weekday += 1;
    }
  }

  // Insert any trailing empty cells
  for (weekday; weekday < 7; weekday += 1) {
    gridCells +=
      '\t\t<td class="empty" role="gridcell" tabindex="-1" aria-label="Cellule vide">&nbsp;</td>\n';
  }

  gridCells += '\t</tr>';

  $tbody.append(gridCells);
};

//
// calcNumDays() is a member function to calculate the number of days in a given month
//
// @return (integer) number of days
//
accessibleDatePicker.prototype.calcNumDays = function calcNumDays(year: number, month: number) {
  return 32 - new Date(year, month, 32).getDate();
};

//
// calcstartWeekday() is a member function to calculate the day of the week the first day of a
// month lands on
//
// @return (integer) number representing the day of the week (0=Sunday....6=Saturday)
//
accessibleDatePicker.prototype.calcStartWeekday = function calcStartWeekday(
  year: number,
  month: number
) {
  // Add 1 to start day to start on Sunday
  const day = new Date(year, month, 0).getDay();
  return day === 6 ? 0 : day + 1;
}; // end calcStartWeekday()

//
// appendYearSelect() is a function to add more or less years to the year select dropdown
// If user is navigating the years with the next/prev buttons we need to shift available years to show prev 10 and next 10
accessibleDatePicker.prototype.appendYearSelect = function appendYearSelect(
  direction: 'forward' | 'backward'
) {
  const options = this.$yearSelect.find('option');
  const lastOption = $(options).last();
  const lastYear = Number($(lastOption).val());
  const firstOption = $(options).first();
  const firstYear = Number($(firstOption).val());
  let newYearToAdd;
  let newOptionToAdd;

  // If user is moving foward we add a year to the select and remove the first year
  if (direction === 'forward') {
    newYearToAdd = lastYear + 1;
    newOptionToAdd = `<option value="${newYearToAdd}">${newYearToAdd}</option>`;
    $(firstOption).remove();
    this.$yearSelect.append(newOptionToAdd);
    // If user is moving backward we remove the last year and prepend the first
  } else {
    newYearToAdd = firstYear - 1;
    newOptionToAdd = `<option value="${newYearToAdd}">${newYearToAdd}</option>`;
    $(lastOption).remove();
    this.$yearSelect.prepend(newOptionToAdd);
  }
};
// @return false;
// end appendYearSelect()

//
// Create date string
// createDateString() creates the current selection as a string to be placed inside the $target input
accessibleDatePicker.prototype.createDateString = function createDateString() {
  const $curDay =
    $(`#${this.$grid.attr('aria-activedescendant')}`).length > 0
      ? $(`#${this.$grid.attr('aria-activedescendant')}`).html()
      : 1;
  let dateString = `${this.year}${this.dateSeperator}${this.month < 9 ? '0' : ''}${this.month + 1}${
    this.dateSeperator
  }${this.prePendZero($curDay)}`;
  if (this.useTimePicker) {
    dateString = `${dateString} ${this.$hourSelect.val()}:${this.$minuteSelect.val()}`;
  }
  const tempDate = window.moment(dateString);
  return tempDate.formatWithJDF(this.dateTimeFormat);
};
// @return String
// end createDateString()

//
// showPrevMonth() is a member function to show the previous month
//
// @param (offset int) offset may be used to specify an offset for setting
//                      focus on a day the specified number of days from
//                      the end of the month.
// @return N/A
//
accessibleDatePicker.prototype.showPrevMonth = function showPrevMonth(offset: number) {
  if (this.yearLimitFrom && this.yearLimitFrom > this.year - 1 && this.month === 0) {
    return;
  }
  // show the previous month
  if (this.month === 0) {
    this.month = 11;
    this.year -= 1;
    // Move visible years inside year select
    this.appendYearSelect('backward');
    this.$monthSelect.val(this.month);
    this.$yearSelect.val(this.year).trigger('change');
  } else {
    this.month -= 1;
    this.$monthSelect.val(this.month).trigger('change');
  }

  this.setCurrentDateValue();

  // if offset was specified, set focus on the last day - specified offset
  if (offset !== null && offset !== undefined) {
    const numDays = this.calcNumDays(this.year, this.month);
    const day = `day${numDays - offset}-${this.uniqueId}`;
    this.setActiveDescendant(day);
  }
  const alertMessage = `Affichage du calendrier de ${this.monthNames[this.month]} ${this.year}`;
  this.alertScreenReader(alertMessage);
}; // end showPrevMonth()

//
// showNextMonth() is a member function to show the next month
//
// @param (offset int) offset may be used to specify an offset for setting
//                      focus on a day the specified number of days from
//                      the beginning of the month.
// @return N/A
//
accessibleDatePicker.prototype.showNextMonth = function showNextMonth(offset: number) {
  if (this.yearLimitTo && this.yearLimitTo < this.year + 1 && this.month === 11) {
    return;
  }
  // show the next month
  if (this.month === 11) {
    this.month = 0;
    this.year += 1;
    // Move visible years inside year select
    this.appendYearSelect('forward');
    this.$monthSelect.val(this.month);
    this.$yearSelect.val(this.year).trigger('change');
  } else {
    this.month += 1;
    this.$monthSelect.val(this.month).trigger('change');
  }

  this.setCurrentDateValue();

  // if offset was specified, set focus on the first day + specified offset
  if (offset !== null && offset !== undefined) {
    const day = `day${offset}-${this.uniqueId}`;
    this.setActiveDescendant(day);
  }
  const alertMessage = `Affichage du calendrier de ${this.monthNames[this.month]} ${this.year}`;
  this.alertScreenReader(alertMessage);
}; // end showNextMonth()

//
// showPrevYear() is a member function to show the previous year
//
// @return N/A
//
accessibleDatePicker.prototype.showPrevYear = function showPrevYear() {
  if (this.yearLimitFrom && this.yearLimitFrom > this.year - 1) {
    return;
  }
  // decrement the year
  this.year -= 1;
  this.setCurrentDateValue();

  // populate the calendar grid
  this.popGrid();
  this.setActiveDescendant();

  this.$monthSelect.val(this.month);
  this.$yearSelect.val(this.year);
  this.appendYearSelect('backward');
  const alertMessage = `Affichage du calendrier de ${this.monthNames[this.month]} ${this.year}`;
  this.alertScreenReader(alertMessage);
}; // end showPrevYear()

//
// showNextYear() is a member function to show the next year
//
// @return N/A
//
accessibleDatePicker.prototype.showNextYear = function showNextYear() {
  if (this.yearLimitTo && this.yearLimitTo < this.year + 1) {
    return;
  }
  // increment the year
  this.year += 1;
  this.setCurrentDateValue();

  // populate the calendar grid
  this.popGrid();
  this.setActiveDescendant();

  this.$monthSelect.val(this.month);
  this.$yearSelect.val(this.year);
  this.appendYearSelect('forward');
  const alertMessage = `Affichage du calendrier de ${this.monthNames[this.month]} ${this.year}`;
  this.alertScreenReader(alertMessage);
}; // end showNextYear()

//
// setCurrentDateValue()
// this.currentDate is true if month / year shown are the real time current month and year
// This is used to set "today" selection inside grid. This function is called before gridPop(), except if setCurrentValueIntoObject() is called first since setCurrentValueIntoObject sets currentDate value
accessibleDatePicker.prototype.setCurrentDateValue = function setCurrentDateValue() {
  this.currentDate = this.curYear === this.year && this.curMonth === this.month;
};
// @return false;
// end setCurrentDateValue();

//
// bindHandlers() is a member function to bind event handlers for the widget
//
// @return N/A
//
accessibleDatePicker.prototype.bindHandlers = function bindHandlers() {
  const self = this;

  //  bind modal close //////////////////////////////////
  if (this.isInsideModal) {
    // f datepicker is open and modal is closed, bindings will remain unbound on body, need to trigger bind release
    // will remain on the datepicker
    // $(this.$modal).off('hidden.bs.modal').on('hidden.bs.modal', function(){
    //     $(document).off('click mousedown mouseup', AccessibleDatePickerModule.accessibleDatePickerForceGridFocus);
    // });
  }

  //  bind button handlers //////////////////////////////////
  this.$prev.click((e: JQuery.ClickEvent<HTMLButtonElement>) => self.handlePrevClick(e));

  this.$next.click((e: JQuery.ClickEvent<HTMLButtonElement>) => self.handleNextClick(e));

  this.$prev.keydown((e: JQuery.ClickEvent<KeyboardEvent>) => self.handlePrevKeyDown(e));

  this.$next.keydown((e: JQuery.ClickEvent<KeyboardEvent>) => self.handleNextKeyDown(e));

  if (this.useTimePicker) {
    this.$confirmButton.focus((e: JQuery.ClickEvent<HTMLButtonElement>) =>
      self.handleConfirmFocus(e)
    );

    this.$confirmButton.keydown((e: JQuery.ClickEvent<KeyboardEvent>) =>
      self.handleConfirmKeyDown(e)
    );

    this.$confirmButton.click((e: JQuery.ClickEvent<HTMLButtonElement>) =>
      self.handleConfirmClick(e)
    );
  }

  // bind select handlers //////////////
  this.$monthSelect.keydown((e: JQuery.ClickEvent<KeyboardEvent>) =>
    self.handleMonthSelectKeyDown(e)
  );
  this.$monthSelect.on('change', (e: JQuery.ClickEvent<HTMLSelectElement>) => {
    self.month = Number(e.currentTarget.value);
    self.setCurrentDateValue();
    self.popGrid();
    self.setActiveDescendant();
  });

  this.$yearSelect.keydown((e: JQuery.ClickEvent<KeyboardEvent>) =>
    self.handleYearSelectKeyDown(e)
  );
  this.$yearSelect.on('change', (e: JQuery.ClickEvent<HTMLSelectElement>) => {
    self.year = Number(e.currentTarget.value);
    self.setCurrentDateValue();
    self.popGrid();
    self.setActiveDescendant();
  });

  if (this.useTimePicker) {
    this.$minuteSelect.keydown((e: JQuery.ClickEvent<KeyboardEvent>) =>
      self.handleMinuteSelectKeyDown(e)
    );

    this.$hourSelect.keydown((e: JQuery.ClickEvent<KeyboardEvent>) =>
      self.handleHourSelectKeyDown(e)
    );
  }

  // bind grid handlers //////////////
  this.$grid.keydown((e: JQuery.ClickEvent<KeyboardEvent>) => self.handleGridKeyDown(e));

  this.$grid.keypress((e: JQuery.ClickEvent<KeyboardEvent>) => self.handleGridKeyPress(e));

  this.$grid.focus((e: JQuery.ClickEvent<HTMLDivElement>) => self.handleGridFocus(e));

  this.$grid.blur((e: JQuery.ClickEvent<HTMLDivElement>) => self.handleGridBlur(e));

  this.$grid.delegate('td', 'click', function click(e: JQuery.ClickEvent) {
    return self.handleGridClick(this, e);
  });
}; // end bindHandlers();

//
// handlePrevClick() is a member function to process click events for the prev month button
//
// @input (e obj) e is the event object associated with the event
//
// @return (boolean) false if consuming event, true if propagating
//
accessibleDatePicker.prototype.handlePrevClick = function handlePrevClick(
  e: JQuery.ClickEvent<HTMLButtonElement>
) {
  // const active = this.$grid.attr('aria-activedescendant');
  if (e.ctrlKey) {
    this.showPrevYear();
  } else {
    this.showPrevMonth();
  }

  e.stopPropagation();
  return false;
}; // end handlePrevClick()

//
// handleNextClick() is a member function to process click events for the next month button
//
// @input (e obj) e is the event object associated with the event
//
// @return (boolean) false if consuming event, true if propagating
//
accessibleDatePicker.prototype.handleNextClick = function handleNextClick(
  e: JQuery.ClickEvent<HTMLButtonElement>
) {
  // const active = this.$grid.attr('aria-activedescendant');

  if (e.ctrlKey) {
    this.showNextYear();
  } else {
    this.showNextMonth();
  }

  e.stopPropagation();
  return false;
}; // end handleNextClick()

//
// handlePrevKeyDown() is a member function to process keydown events for the prev month button
//
// @input (e obj) e is the event object associated with the event
//
// @return (boolean) false if consuming event, true if propagating
//
accessibleDatePicker.prototype.handlePrevKeyDown = function handlePrevKeyDown(
  e: JQuery.ClickEvent<KeyboardEvent>
) {
  if (e.altKey) {
    return true;
  }

  switch (e.keyCode) {
    case this.keys.tab: {
      if (this.bModal === false || !e.shiftKey || e.ctrlKey) {
        return true;
      }
      if (this.useTimePicker) {
        this.$confirmButton.focus();
      } else {
        this.$grid.focus();
      }
      e.stopPropagation();
      return false;
    }
    case this.keys.enter:
    case this.keys.space: {
      if (e.shiftKey) {
        return true;
      }

      if (e.ctrlKey) {
        this.showPrevYear();
      } else {
        this.showPrevMonth();
      }

      e.stopPropagation();
      return false;
    }
    default: {
      return true;
    }
  }
}; // end handlePrevKeyDown()

//
// handleNextKeyDown() is a member function to process keydown events for the next month button
//
// @input (e obj) e is the event object associated with the event
//
// @return (boolean) false if consuming event, true if propagating
//
accessibleDatePicker.prototype.handleNextKeyDown = function handleNextKeyDown(
  e: JQuery.ClickEvent<KeyboardEvent>
) {
  if (e.altKey) {
    return true;
  }
  switch (e.keyCode) {
    case this.keys.up:
    case this.keys.down:
    case this.keys.left:
    case this.keys.right: {
      e.stopPropagation();
      return false;
    }
    case this.keys.enter:
    case this.keys.space: {
      if (e.ctrlKey) {
        this.showNextYear();
      } else {
        this.showNextMonth();
      }

      e.stopPropagation();
      return false;
    }
    default: {
      return true;
    }
  }
}; // end handleNextKeyDown()

//
// handleConfirmFocus() is a member function to process keydown events for the confirm button
//
// @input (e obj) e is the event object associated with the event
//
// @return (boolean) false if consuming event, true if propagating
//
accessibleDatePicker.prototype.handleConfirmFocus = function handleConfirmFocus() {
  // On focus we'll change the label of the confirm button to include the date chosen by the user
  const activeDescdendantHTML = $(`#${this.$grid.attr('aria-activedescendant')}`).html();
  const currentDateSelected = `${activeDescdendantHTML} ${this.monthNames[this.month]} ${
    this.year
  } ${this.$hourSelect.val()} heures et ${this.$minuteSelect.val()} minutes`;
  const confirmButtonTitle = ($(this.$confirmButton).attr('title') as string).split(':')[0];
  const title = `${confirmButtonTitle}: ${currentDateSelected}`;

  $(this.$confirmButton).attr('title', title);
};
// @return false;
// end handleConfirmKeyDown()

//
// handleConfirmKeyDown() is a member function to process keydown events for the confirm button
//
// @input (e obj) e is the event object associated with the event
//
// @return (boolean) false if consuming event, true if propagating
//
accessibleDatePicker.prototype.handleConfirmKeyDown = function handleConfirmKeyDown(
  e: JQuery.ClickEvent<HTMLButtonElement>
) {
  let dateString;

  if (e.altKey) {
    return true;
  }

  switch (e.keyCode) {
    case this.keys.tab: {
      if (this.bModal === true) {
        if (e.shiftKey) {
          this.$minuteSelect.focus();
        } else {
          this.$prev.focus();
        }
      }
      break;
    }
    case this.keys.enter:
    case this.keys.space: {
      // update the target box
      dateString = this.createDateString();
      this.$target.val(dateString).trigger('change');
      // fall through
      // dismiss the dialog box
      this.hideDlg();
      break;
    }
    case this.keys.up: {
      this.$minuteSelect.focus();
      break;
    }
    case this.keys.left: {
      this.$minuteSelect.focus();
      break;
    }
    case this.keys.down: {
      this.$monthSelect.focus();
      break;
    }
    case this.keys.right: {
      this.$monthSelect.focus();
      break;
    }
    default: {
      e.stopPropagation();
      return false;
    }
  }
  return false;
}; // end handleConfirmKeyDown()

accessibleDatePicker.prototype.handleMonthSelectKeyDown = function handleMonthSelectKeyDown(
  e: JQuery.ClickEvent<KeyboardEvent>
) {
  if (e.altKey) {
    return true;
  }
  switch (e.keyCode) {
    case this.keys.up:
    case this.keys.down: {
      return true;
    }
    case this.keys.tab: {
      if (this.bModal === true) {
        if (e.shiftKey) {
          this.$prev.focus();
        } else {
          this.$yearSelect.focus();
        }
      }
      break;
    }
    case this.keys.enter:
    case this.keys.space: {
      this.$yearSelect.focus();
      break;
    }
    default: {
      // fall through
      e.stopPropagation();
      return false;
    }
  }
  return true;
};

accessibleDatePicker.prototype.handleYearSelectKeyDown = function handleYearSelectKeyDown(
  e: JQuery.ClickEvent<KeyboardEvent>
) {
  if (e.altKey) {
    return true;
  }
  switch (e.keyCode) {
    case this.keys.up:
    case this.keys.down: {
      return true;
    }
    case this.keys.tab: {
      if (this.bModal === true) {
        if (e.shiftKey) {
          this.$monthSelect.focus();
        } else {
          this.$next.focus();
        }
      }
      break;
    }
    case this.keys.enter:
    case this.keys.space: {
      this.$grid.focus();
      break;
    }
    default: {
      // fall through
      e.stopPropagation();
      return false;
    }
  }
  return false;
};

accessibleDatePicker.prototype.handleHourSelectKeyDown = function handleHourSelectKeyDown(
  e: JQuery.ClickEvent<KeyboardEvent>
) {
  if (e.altKey) {
    return true;
  }
  switch (e.keyCode) {
    case this.keys.up:
    case this.keys.down: {
      return true;
    }
    case this.keys.tab: {
      if (this.bModal === true) {
        if (e.shiftKey) {
          this.$grid.focus();
        } else {
          this.$minuteSelect.focus();
        }
      }
      break;
    }
    case this.keys.enter:
    case this.keys.space: {
      this.$minuteSelect.focus();
      break;
    }
    default: {
      // fall through
      e.stopPropagation();
      return false;
    }
  }
  return false;
};

accessibleDatePicker.prototype.handleMinuteSelectKeyDown = function handleMinuteSelectKeyDown(
  e: JQuery.ClickEvent<KeyboardEvent>
) {
  if (e.altKey) {
    return true;
  }
  switch (e.keyCode) {
    case this.keys.up:
    case this.keys.down: {
      return true;
    }
    case this.keys.tab: {
      if (this.bModal === true) {
        if (e.shiftKey) {
          this.$hourSelect.focus();
        } else {
          this.$confirmButton.focus();
        }
      }
      break;
    }
    case this.keys.enter:
    case this.keys.space: {
      this.$confirmButton.focus();
      break;
    }
    default: {
      // fall through
      e.stopPropagation();
      return false;
    }
  }
  return false;
};

//
// handleConfirmClick() is a member function to click events for the confirm button
//
// @input (e obj) e is the event object associated with the event
//
// @return (boolean) false if consuming event, true if propagating
//
accessibleDatePicker.prototype.handleConfirmClick = function handleConfirmClick(
  e: JQuery.ClickEvent<HTMLButtonElement>
) {
  // update the target box
  const dateString = this.createDateString();
  this.$target.val(dateString).trigger('change');

  // dismiss the dialog box
  this.hideDlg();

  e.stopPropagation();
  return false;
}; // end handleConfirmClick()

//
// handleGridKeyDown() is a member function to process keydown events for the datepicker grid
//
// @input (e obj) e is the event object associated with the event
//
// @return (boolean) false if consuming event, true if propagating
//
accessibleDatePicker.prototype.handleGridKeyDown = function handleGridKeyDown(
  e: JQuery.ClickEvent<KeyboardEvent>
) {
  // const $rows = this.$grid.find('tbody tr');
  const $curDay = $(`#${this.$grid.attr('aria-activedescendant')}`);
  const $days = this.$grid.find('td').not('.empty');
  // const $curRow = $curDay.parent();
  let $prevDay;
  let $nextDay;
  let dateString;
  let dayIndex;
  let active;
  let lastDay;

  if (e.altKey) {
    return true;
  }

  switch (e.keyCode) {
    case this.keys.tab: {
      if (this.bModal === true) {
        if (e.shiftKey) {
          this.$next.focus();
        } else if (this.useTimePicker) {
          this.$hourSelect.focus();
        } else {
          this.$prev.focus();
        }

        e.stopPropagation();
        return false;
      }
      break;
    }
    case this.keys.enter:
    case this.keys.space: {
      if (e.ctrlKey || $curDay.hasClass('disabled')) {
        return true;
      }
      if (this.useTimePicker) {
        // Focus on hour select
        this.$hourSelect.focus();
        e.stopPropagation();
        return false;
      }
      // update the target box
      dateString = this.createDateString();
      this.$target.val(dateString).trigger('change');
      // fall through
      return false;
    }
    case this.keys.esc: {
      // dismiss the dialog box
      this.hideDlg();

      e.stopPropagation();
      return false;
    }
    case this.keys.left: {
      if (e.ctrlKey || e.shiftKey) {
        return true;
      }

      dayIndex = $days.index($curDay) - 1;
      $prevDay = null;

      if (dayIndex >= 0) {
        $prevDay = $days.eq(dayIndex);
        this.setActiveDescendant($prevDay.attr('id'));
      } else {
        this.showPrevMonth(0);
      }

      e.stopPropagation();
      return false;
    }
    case this.keys.right: {
      if (e.ctrlKey || e.shiftKey) {
        return true;
      }

      dayIndex = $days.index($curDay) + 1;
      $nextDay = null;

      if (dayIndex < $days.length) {
        $nextDay = $days.eq(dayIndex);
        this.setActiveDescendant($nextDay.attr('id'));
      } else {
        // move to the next month
        this.showNextMonth(1);
      }

      e.stopPropagation();
      return false;
    }
    case this.keys.up: {
      if (e.ctrlKey || e.shiftKey) {
        return true;
      }

      dayIndex = $days.index($curDay) - 7;
      $prevDay = null;

      if (dayIndex >= 0) {
        $prevDay = $days.eq(dayIndex);
        this.setActiveDescendant($prevDay.attr('id'));
      } else {
        // move to appropriate day in previous month
        dayIndex = 6 - $days.index($curDay);
        this.showPrevMonth(dayIndex);
      }

      e.stopPropagation();
      return false;
    }
    case this.keys.down: {
      if (e.ctrlKey || e.shiftKey) {
        return true;
      }

      dayIndex = $days.index($curDay) + 7;
      $prevDay = null;

      if (dayIndex < $days.length) {
        $prevDay = $days.eq(dayIndex);
        this.setActiveDescendant($prevDay.attr('id'));
      } else {
        // move to appropriate day in next month
        dayIndex = 8 - ($days.length - $days.index($curDay));

        this.showNextMonth(dayIndex);
      }

      e.stopPropagation();
      return false;
    }
    case this.keys.pageup: {
      active = this.$grid.attr('aria-activedescendant');

      if (e.shiftKey) {
        return true;
      }

      if (e.ctrlKey) {
        this.showPrevYear();
      } else {
        this.showPrevMonth();
      }

      if ($(`#${active}`).attr('id') === undefined) {
        lastDay = `day${this.calcNumDays(this.year, this.month)}-${this.uniqueId}`;
        this.setActiveDescendant(lastDay);
      } else {
        this.setActiveDescendant(active);
      }

      e.stopPropagation();
      return false;
    }
    case this.keys.pagedown: {
      active = this.$grid.attr('aria-activedescendant');

      if (e.shiftKey) {
        return true;
      }

      if (e.ctrlKey) {
        this.showNextYear();
      } else {
        this.showNextMonth();
      }

      if ($(`#${active}`).attr('id') === undefined) {
        lastDay = `day${this.calcNumDays(this.year, this.month)}-${this.uniqueId}`;
        this.setActiveDescendant(lastDay);
      } else {
        this.setActiveDescendant(active);
      }

      e.stopPropagation();
      return false;
    }
    case this.keys.home: {
      if (e.ctrlKey || e.shiftKey) {
        return true;
      }
      this.setActiveDescendant(`day1-${this.uniqueId}`);

      e.stopPropagation();
      return false;
    }
    case this.keys.end: {
      if (e.ctrlKey || e.shiftKey) {
        return true;
      }
      lastDay = `day${this.calcNumDays(this.year, this.month)}-${this.uniqueId}`;
      this.setActiveDescendant(lastDay);

      e.stopPropagation();
      return false;
    }
    default: {
      return true;
    }
  }
  return true;
}; // end handleGridKeyDown()

//
// handleGridKeyPress() is a member function to consume keypress events for browsers that
// use keypress to scroll the screen and manipulate tabs
//
// @input (e obj) e is the event object associated with the event
//
// @return (boolean) false if consuming event, true if propagating
//
accessibleDatePicker.prototype.handleGridKeyPress = function handleGridKeyPress(
  e: JQuery.ClickEvent<KeyboardEvent>
) {
  if (e.altKey) {
    return true;
  }

  switch (e.keyCode) {
    case this.keys.tab:
    case this.keys.enter:
    case this.keys.space:
    case this.keys.esc:
    case this.keys.left:
    case this.keys.right:
    case this.keys.up:
    case this.keys.down:
    case this.keys.pageup:
    case this.keys.pagedown:
    case this.keys.home:
    case this.keys.end: {
      e.stopPropagation();
      return false;
    }
    default: {
      return true;
    }
  }
}; // end handleGridKeyPress()

//
// handleGridClick() is a member function to process mouse click events for the datepicker grid
//
// @input (id obj) e is the id of the object triggering the event
//
// @input (e obj) e is the event object associated with the event
//
// @return (boolean) false if consuming event, true if propagating
//
accessibleDatePicker.prototype.handleGridClick = function handleGridClick(
  id: string,
  e: JQuery.ClickEvent<HTMLDivElement>
) {
  const $cell = $(id);
  let dateString;

  if ($cell.hasClass('empty') || $cell.hasClass('disabled')) {
    return true;
  }

  this.setActiveDescendant($cell.attr('id'));

  if (!this.useTimePicker) {
    // update the target box
    dateString = this.createDateString();
    this.$target.val(dateString).trigger('change');

    // dismiss the dialog box
    this.hideDlg();
  }
  e.stopPropagation();
  return false;
}; // end handleGridClick()

//
// handleGridFocus() is a member function to process focus events for the datepicker grid
//
// @input (e obj) e is the event object associated with the event
//
// @return (boolean) true
//
accessibleDatePicker.prototype.handleGridFocus = function handleGridFocus() {
  this.$grid.addClass('active');
  const active = this.$grid.attr('aria-activedescendant');
  let lastDay;

  if ($(`#${active}`).attr('id') === undefined) {
    lastDay = `day${this.calcNumDays(this.year, this.month)}-${this.uniqueId}`;
    this.setActiveDescendant(lastDay);
  } else {
    this.setActiveDescendant(active);
  }

  return true;
}; // end handleGridFocus()

//
// handleGridBlur() is a member function to process blur events for the datepicker grid
//
// @input (e obj) e is the event object associated with the event
//
// @return (boolean) true
//
accessibleDatePicker.prototype.handleGridBlur = function handleGridBlur() {
  this.$grid.removeClass('active');
  return true;
}; // end handleGridBlur()

//
// showDlg() is a member function to show the datepicker and give it focus. This function is only called if
// the datepicker is used in modal dialog mode.
//
// @return N/A
//

accessibleDatePicker.prototype.showDlg = function showDlg() {
  const self = this;
  // currentDateObject = this.getDateObject(),
  // currentDateObjectDay = currentDateObject.getDate(),
  // currentDateObjectYear = currentDateObject.getFullYear(),
  // currentDateObjectMonth = currentDateObject.getMonth();

  // Removed mousemove mouseover
  // $(document).on('click mousedown mouseup', self, AccessibleDatePickerModule.accessibleDatePickerForceGridFocus);
  $(document)
    .off('click mousedown mouseup keydown', '.accessible-datepicker-closer.open')
    .on('click mousedown mouseup keydown', '.accessible-datepicker-closer', (e: any) => {
      AccessibleDatePickerModule.accessibleDatePickerForceGridFocus($(e.currentTarget), e, self);
    });

  // // Bind an event listener to the document to capture all mouse events to make dialog modal
  // $(document).bind('click mousedown mouseup mousemove mouseover', function(e) {
  //  //ensure focus remains on the dialog
  //  self.$grid.focus();

  //  // Consume all mouse events and do nothing
  //  e.stopPropagation;
  //  return false;
  // });

  // Check if value is present and set correct values
  this.setCurrentValueIntoObject();
  this.popGrid();
  this.setActiveDescendant();
  // display the current month
  // this.$monthObj.html(this.monthNames[this.month] + ' ' + this.year);

  // show the dialog
  this.$id.attr('aria-hidden', 'false').addClass('open');
  this.$accessibleDatepickerCloser.attr('aria-hidden', 'false').addClass('open');
  // Bind datepicker positioning to window scroll and resize

  window.DexeroCoreApp.setLastPopedPopover(this.$target, this.$id);
  window.DexeroCoreApp.positionLastPopedPopover();
  this.$grid.focus();
}; // end showDlg()

//
// hideDlg() is a member function to hide the datepicker and remove focus. This function is only called if
// the datepicker is used in modal dialog mode.
//
// @return N/A
//
accessibleDatePicker.prototype.hideDlg = function hideDlg() {
  // unbind the modal event sinks
  // $(document).unbind('click mousedown mouseup mousemove mouseover');
  // $(document).off('click mousedown mouseup', AccessibleDatePickerModule.accessibleDatePickerForceGridFocus);

  // Unbind datepicker positioning from window scroll and resize
  window.DexeroCoreApp.resetLastPopedPopover();

  // hide the dialog
  this.$id.attr('aria-hidden', 'true').removeClass('open');
  this.$accessibleDatepickerCloser.attr('aria-hidden', 'true').removeClass('open');

  // set focus on the focus target
  this.$target.focus();

  // Callback function to call on datepicker close
  if (this.callBackFn) {
    if (typeof this.callBackFn === 'function') {
      this.callBackFn();
      return;
    }

    // eslint-disable-next-line no-eval
    eval(this.callBackFn);
  }
}; // end showDlg()

const AccessibleDatePickerModule: IAccessibleDatePickerModule = {
  accessibleDatePicker,
  accessibleDatePickerForceGridFocus,
};

export default AccessibleDatePickerModule;
